module.exports = __webpack_public_path__ + "img/B06932_451B09_7B3E16_150804-256px.09afc56e.png";